export default "__VITE_ASSET__DBQnutg6__"